import { t } from '@lingui/core/macro'

function azureCostKinds() {
  return [
    { label: t`Actual Cost`, value: 'ActualCost', default: true },
    { label: t`Amortized Cost`, value: 'AmortizedCost' },
  ]
}

export { azureCostKinds }
